import { Link } from "react-router-dom";
import './header.css';
import logo from '../../assets/images/Header/header-logo-dark.png'; 
import React from "react";

export default function Header() {
  const services = [
    { path: "/services", label: "All Services" },
    { path: "/chiller-van-for-rent", label: "Chiller Van for Rent" },
    { path: "/chiller-truck-for-rent", label: "Chiller Truck for Rent" },
    { path: "/refrigerated-trucks-for-rent", label: "Refrigerated Trucks for Rent" },
    { path: "/freezer-van-for-rent", label: "Freezer Van for Rent" },
    { path: "/freezer-truck-for-rent", label: "Freezer Truck for Rent" },
    { path: "/high-roof-dry-van-for-rent", label: "High Roof Dry Van for Rent" },
    { path: "/truck-rental-in-fujairah", label: "Truck Rental in Fujairah" },
    { path: "/van-rental-in-dubai", label: "Van Rental in Dubai" },
    { path: "/chiller-van-for-rent-in-sharjah", label: "Chiller Van for Rent in Sharjah" },
    { path: "/chiller-van-for-rent-in-abu-dhabi", label: "Chiller Van for Rent in Abu Dhabi" },
    { path: "/chiller-van-for-rent-in-ras-al-khor", label: "Chiller Van for Rent in Ras Al Khor" },
    { path: "/chiller-van-for-rent-in-al-barsha", label: "Chiller Van for Rent in Al Barsha" },
    { path: "/chiller-van-for-rent-in-al-quoz", label: "Chiller Van for Rent in Al Quoz" },
    { path: "/chiller-van-for-rent-in-jebel-ali", label: "Chiller Van for Rent in Jebel Ali" },
    { path: "/chiller-van-for-rent-in-dubai-investment-park", label: "Chiller Van for Rent in Dubai Investment Park" },
  ];

  return (
    <header className="header">
      <section className="topbar">
        <div className="container-fluid">
          <div className="topbar-inner">

            {/* LEFT: Contact Info */}
            <div className="contact-info">
              <span>
                <i className="bi bi-geo-alt-fill"></i>
                <a href="https://maps.app.goo.gl/TtJxd7RwBfBBMYCy9" target="_blank" rel="noopener noreferrer">
                Ras Al Khor Industrial Area - Ras Al Khor Industrial Area 1- Dubai - UAE
                </a>
              </span>

              <span>
                <i className="bi bi-telephone-fill"></i>
                <a href="tel:+971544792905">+971544792905</a>
              </span>

              <span>
                <i className="bi bi-envelope-fill"></i>
                <a href="mailto:info@chillerfleet.com">info@chillerfleet.com</a>
              </span>
            </div>

            <div className="social-links">
              <a href="https://www.instagram.com/chillerfleet.1/" aria-label="instagram"  target="_blank" rel="noopener noreferrer">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="https://www.facebook.com/people/Chiller-Fleet-Rental/61584466431433/"  aria-label="facebook"    target="_blank" rel="noopener noreferrer">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="https://www.linkedin.com/company/chiller-fleet-transport/"  aria-label="linkedin"   target="_blank" rel="noopener noreferrer">
                <i className="bi bi-linkedin"></i>
              </a>
              <a href="https://www.tiktok.com/@chiller.fleet?_r=1&_t=ZS-95ElkFiaxQO"  aria-label="tiktok"   target="_blank" rel="noopener noreferrer">
                <i className="bi bi-tiktok"></i>
              </a>
            </div>
          </div>
        </div>
      </section>
      <nav className="navbar navbar-expand-lg ">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src={logo} alt="ChillerFleet Logo" className="logo img-fluid" />
          </Link>

          <button 
            className="navbar-toggler" 
            type="button" 
            data-bs-toggle="collapse" 
            data-bs-target="#navbarNav" 
            aria-controls="navbarNav" 
            aria-expanded="false" 
            aria-label="Toggle navigation"
          >

          <span className="toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">Home</Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/about-us">About Us</Link>
              </li>

              {/* Services dropdown */}
              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle"
                  to="/services"
                  id="servicesDropdown"
                  role="button" 
                  data-bs-toggle="dropdown" 
                  aria-expanded="false"
                >
                  Services
                </Link>

                {/* Visible dropdown */}
                <ul className="dropdown-menu" aria-labelledby="servicesDropdown">
                  {services.map((service, idx) => (
                    <li key={idx}>
                      <Link className="dropdown-item" to={service.path}>{service.label}</Link>
                    </li>
                  ))}
                </ul>

              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/blog">Blog</Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/contact-us">Contact Us</Link>
              </li>

      
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}